import {useState} from "react";
import {passHidden, passVisible} from "../../../../assets/icons/icons.ts";

export const useVisibilityToggle = () => {
    const [isShown, setIsShown] = useState(false)

    const visibilityToggle = <img
        src={isShown ? passVisible : passHidden}
        alt='Кнопка показать пароль'
        onClick={() => setIsShown(!isShown)}
    />

    return {isShown, visibilityToggle}
}